<template>
  <div id="footer">
    <div class="info">
      <div class="container">
        <div class="company-name">洋宇集团有限公司</div>
        <div class="company-info">
          <div class="socity"></div>
          <div class="info-list">
            <div class="one">
              <div class="content">地址:{{ footerData.address }}</div>
            </div>
            <div class="one"><div class="content">邮编:325000</div></div>
            <div class="one" v-if="footerData.tel != ''">
              <div class="content">电话:{{ footerData.tel }}</div>
            </div>
            <div class="one" v-if="footerData.time != ''">
              <div class="content">手机:{{ footerData.time }}</div>
            </div>
            <div class="one" v-if="footerData.fax != ''">
              <div class="content">传真:{{ footerData.fax }}</div>
            </div>
            <div class="one" v-if="footerData.email != ''">
              <div class="content">邮箱:{{ footerData.email }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright">
      <div class="content">
        {{ copyright }}
        <a href="https://beian.miit.gov.cn/#/Integrated/index">{{ beian }}</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "vfooter",
  data() {
    return {
      beian: "",
      copyright: "",
      footerData: {},
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.axios
        .get("/api/config/get")
        .then((res) => {
          this.beian = res.data.data.beian;
          this.copyright = res.data.data.copyright;
        })
        .catch((err) => {
          console.log(err);
        });
      this.axios
        .get("/api/index/contact")
        .then((res) => {
          this.footerData = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};

</script>
<style scoped>
#footer {
  width: 100%;
  height: 354px;
}

#footer .info {
  width: 100%;
  height: 311px;
  background: #f3f3f3;
}

#footer .info .container {
  width: 1200px;
  margin: 0 auto;
  padding: 96px 0 0 0;
}

#footer .company-name {
  font-size: 22px;
  font-weight: 500;
  color: #333333;
}

#footer .info-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 38px;
}

#footer .info-list .one {
  width: 398px;
  height: 23px;
}

#footer .info-list .one .content {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
}

#footer .copyright {
  background: #323232;
  width: 100%;
  height: 54px;
}

#footer .copyright .content {
  width: 1200px;
  margin: 0 auto;
  color: white;
  line-height: 54px;
  font-size: 16px;
  text-align: center;
}

#footer .copyright .content a {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/sub/Footer.vue